// don't use Logger here, since this is used for translations in the logger module itself

class Translate {
    translation = null;
    constructor() {
        this.translation = window?.mscp?.translation;
    }

    getTranslation(key) {
        if (!this.translation) {
            console.error("No translations found.");
            return key;
        }
        if (!this.translation[key]) {
            console.debug("No translation found for key %s", key);
            return key;
        }
        return this.translation[key];
    }
}

const trans = new Translate();

const _ = (key, args = null) => {
    let translation = trans.getTranslation(key);

    if (args) {
        if (!Array.isArray(args)) {
            args = [args]; // Om det bara är ett argument, gör det till en array
        }
        args.forEach(arg => {
            translation = translation.replace('%s', arg);
        });
    }

    return translation;
};


export default _;